import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21.968}
      height={21.968}
      viewBox="0 0 21.968 21.968"
      {...props}
    >
      <g
        data-name="Icon feather-save"
        fill="none"
        stroke="#18206b"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          data-name="Path 10792"
          d="M19.138 21.468H2.83a2.33 2.33 0 01-2.33-2.33V2.83A2.33 2.33 0 012.83.5h12.813l5.824 5.824v12.814a2.33 2.33 0 01-2.329 2.33z"
        />
        <path data-name="Path 10793" d="M16.809 21.468v-9.319H5.16v9.319" />
        <path data-name="Path 10794" d="M5.16.5v5.824h9.319" />
      </g>
    </svg>
  )
}

export default SvgComponent
